export default __webpack_public_path__ + "assets/images/tax-harvesting-banner.svg";